import { render, staticRenderFns } from "./statutoryDeduction.vue?vue&type=template&id=c2b9c134&scoped=true"
import script from "./statutoryDeduction.vue?vue&type=script&lang=js"
export * from "./statutoryDeduction.vue?vue&type=script&lang=js"
import style0 from "./statutoryDeduction.vue?vue&type=style&index=0&id=c2b9c134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b9c134",
  null
  
)

export default component.exports